module.exports = __webpack_public_path__ + "static/media/input3.1e3a4e88.jpg";